import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jrrbl9v: FaireProductEntity = {
  token: "p_8jrrbl9v",
  type: "product",
  name: "Sea Salt Surf Room & Linen Spray",
  brandName: "Broken Top Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/31789c52c50cdaf1ae1da4cb51c3c15e06ac394e2e8421d689e63faa478f86ee.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a8c18c47d399c85c79e9bb201f45d8fd76832eec8c2380716d7eea77ad2909d2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
